import React, { useState } from "react";
import { Hero } from "../components/home/Hero";
import { CertificationStrip } from "../components/home/CertificationStrip";
import { CategoryExplorer } from "../components/home/CategoryExplorer";
import { IngredientCatalogue } from "../components/home/IngredientCatalogue";
import { ProcessSection } from "../components/home/ProcessSection";
import { EstateSection } from "../components/home/EstateSection";
import { QualitySection } from "../components/home/QualitySection";
import { QuoteSection } from "../components/home/QuoteSection";
import { CategoryId } from "../types/ingredient";
import { scrollToId } from "../utils/scroll";
export function Home() {
  const [activeCategory, setActiveCategory] = useState<CategoryId | "all">("all");
  return <>
      <Hero data-id="element-333" data-mp="3kvk62l8hf36i" />
      <CertificationStrip data-id="element-334" data-mp="3kvtmbh3q5vz0" />
      <CategoryExplorer onSelect={id => {
      setActiveCategory(id);
      scrollToId("catalogue");
    }} data-id="element-335" data-mp="3kuijbji3ss8y" />
      <IngredientCatalogue activeCategory={activeCategory} onCategoryChange={setActiveCategory} data-id="element-336" data-mp="3oyqbjqnrsqbx" />
      <ProcessSection data-id="element-337" data-mp="30uf948u15x54" />
      <EstateSection data-id="element-338" data-mp="2vxydktki4gi0" />
      <QualitySection data-id="element-339" data-mp="2vyq77yujg45n" />
      <QuoteSection data-id="element-340" data-mp="2vy85imp3wxqc" />
    </>;
}